import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  logOut, goToProfile, updateFilter, getUsers, switchUserType,
  setUserType, getUserData, toggleProfile, getProfilePhoto,
} from '../../actions';
import Navbar from './component';

export const mapStateToProps = state => (
  {
    authenticated: state.user.authenticated,
    done: state.survey.done,
    users: state.feed.users,
    name: state.user.name,
    userType: state.user.userType,
    filter: state.feed.filter,
    profileOpen: state.user.profileOpen,
  }
);

export default connect(mapStateToProps, {
  logOut,
  goToProfile,
  updateFilter,
  getUsers,
  switchUserType,
  setUserType,
  getUserData,
  toggleProfile,
  getProfilePhoto,
})(withRouter(Navbar));
